import { compact } from 'lodash-es';
import { extractPureTextFromRichText } from 'seagull';
import { approvalMethodNoticePeriodModel, relationshipModel, serviceModel } from '~/models';
import { requestAccountantAccessModel } from '~/models/request-accountant-access';
export const additionalTermsTextsPath = 'clientFlow.additionalTerms';
const hasAgreementNotes = (extraClause)=>!!extraClause && extractPureTextFromRichText(extraClause).trim().length > 0;
export const hasTerms = (terms)=>!!terms && extractPureTextFromRichText(terms).trim().length > 0;
function getIncludedServices(param) {
    let { relationship, selectedBundleId, selectedOptionalServiceIds } = param;
    var _ref;
    const bundleId = (_ref = selectedBundleId !== null && selectedBundleId !== void 0 ? selectedBundleId : relationshipModel.selectedBundleId(relationship)) !== null && _ref !== void 0 ? _ref : undefined;
    const services = relationshipModel.actualServices(relationship, bundleId);
    const selectedOptional = new Set(selectedOptionalServiceIds !== null && selectedOptionalServiceIds !== void 0 ? selectedOptionalServiceIds : relationshipModel.selectedOptionalServices(relationship));
    return services.filter((s)=>serviceModel.isMandatory(s.participation) || selectedOptional.has(s.id));
}
export function getServiceTermsEntries(param) {
    let { relationship, selectedBundleId, selectedOptionalServiceIds, services } = param;
    const included = services !== null && services !== void 0 ? services : getIncludedServices({
        relationship,
        selectedBundleId,
        selectedOptionalServiceIds
    });
    const entries = [];
    for (const service of included){
        if (!service.bundle && hasTerms(service.terms)) {
            entries.push({
                key: 'serviceTerms',
                serviceId: service.id,
                title: service.name,
                description: service.terms
            });
        }
        if (service.bundle) {
            for (const includedService of service.bundle.services){
                if (hasTerms(includedService.terms)) {
                    entries.push({
                        key: 'serviceTerms',
                        serviceId: includedService.id,
                        title: includedService.name,
                        description: includedService.terms
                    });
                }
            }
        }
    }
    return entries;
}
export const getAdditionalTermsData = (relationship, rootTexts)=>{
    var _relationship_extraClause;
    const additionalTermsTexts = rootTexts.clientFlow.additionalTerms;
    const onAcceptanceTexts = rootTexts.models.service.validation;
    const approvalMethodNoticePeriodTexts = rootTexts.models.approvalMethodNoticePeriod;
    return compact([
        {
            key: 'effectiveDate',
            title: additionalTermsTexts.effectiveDate(),
            description: relationshipModel.formatEffectiveDate(relationship, onAcceptanceTexts)
        },
        {
            key: 'paymentTerms',
            title: additionalTermsTexts.paymentTerms(),
            description: relationshipModel.paymentTermsText(relationship, additionalTermsTexts)
        },
        {
            key: 'amendments',
            title: additionalTermsTexts.amendments(),
            description: approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod, approvalMethodNoticePeriodTexts)
        },
        approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && {
            key: 'outOfScopeCharges',
            title: additionalTermsTexts.outOfScopeCharges(),
            description: approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod, approvalMethodNoticePeriodTexts)
        },
        requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && {
            key: 'accountantAccess',
            title: additionalTermsTexts.accountantAccess(),
            description: additionalTermsTexts.accountantAccessDescription({
                vendorName: relationship.vendor.name
            })
        },
        hasAgreementNotes(relationship.extraClause) && {
            key: 'agreementNotes',
            title: additionalTermsTexts.agreementNotes(),
            description: (_relationship_extraClause = relationship.extraClause) !== null && _relationship_extraClause !== void 0 ? _relationship_extraClause : ''
        }
    ]);
};
